import { EditableCard } from "../../../components/editableCard.component";
import { ApiSchemaPatient } from "../../../models/api";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";
import { FileList } from "../../../components/fileList.component";
import serviceAuthorizationFileLogo from "../../../assets/img/service-authorization-file.svg";
import formFileLogo from "../../../assets/img/form-file.svg";

type Props = {
  data: ApiSchemaPatient | undefined;
  isValidating: boolean;
};

export const FormsCard = (props: Props) => {
  const { patientId } = useParams<{ patientId: string }>();
  return (
    <EditableCard
      link={`${AppRouteUi.Patient.Root()}/update/${patientId}`}
      title="Forms"
      showLoader
      className="mb-3"
      isValidating={props.isValidating}
    >
      <div>
        <p className="text-green-200 mb-2">Service authorization files</p>
        {props.data?.serviceAuthorizationFile?.length ? (
          <div className="mt-2 mb-4">
            <FileList
              files={props.data?.serviceAuthorizationFile}
              icon={serviceAuthorizationFileLogo}
              underScoreCount={5}
            />
          </div>
        ) : (
          "No Data Available."
        )}

        <p className="text-green-200 mb-2">Form files</p>
        {props.data?.formAttachFile?.length ? (
          <div className="mt-2">
            <FileList
              files={props.data?.formAttachFile}
              icon={formFileLogo}
              underScoreCount={5}
            />
          </div>
        ) : (
          "No Data Available."
        )}

        {/* {!props.data?.serviceAuthorizationFile?.length &&
          !props.data?.formAttachFile?.length && <p>No files</p>} */}
      </div>
    </EditableCard>
  );
};
